<template>
    <footer id="footer" v-if="show" class="footer">
        <!--<div class="footer-above container">
            <router-link :to="i18nLink()">
                <img v-if="coreParams.shop_asset_image"
                     :src="coreParams.shop_asset_image.logo_original" :alt="shopId">
            </router-link>
            <div class="footer-above-contacts">
                <div class="address">
                    <h5>{{ $t('address') }}</h5>
                    <span>{{ coreParams.title }}</span>
                    <span>Some str.</span>
                    <span>ZIP State, Österreich</span>
                </div>
                <div class="contact">
                    <h5>{{ $tc('contact', 1) }}</h5>
                    <span>{{ $tc('telephone', 1) }}: {{ coreParams.contact_phone }}</span>
                    <span>{{ $t('fax') }}: {{ coreParams.contact_fax }}</span>
                    <span>{{ coreParams.contact_email }}</span>
                </div>
            </div>
        </div>-->
        <div class="footer-under">
            <div class="footer-under-wrapper container">
                <div class="footer-copyright">
                    <span>{{ $t('copyright', { shop: coreParams.title }) }}</span>
                </div>
                <div class="links">
                    <router-link class="link" v-for='(link, i) in footerLinks' :key='i'
                                 :to='link.linkTo'>{{ link.linkName }}</router-link>
                </div>
            </div>
        </div>
    </footer>
</template>

<style lang="scss" scoped>
    .footer {

        &-under {
            padding: 28px 0;
            color: var(--text-color);
            background-color: var(--bg-secondary-color);

            &-wrapper {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 100%;

                @media (max-width: 768px) {
                    flex-direction: column;
                    text-align: center;
                }

                span,
                .link {
                    font-size: .87rem;
                    color: inherit;
                }

                .links {
                    @media (max-width: 768px) {
                        margin-top: 10px;
                    }

                    .link {
                        margin-left: 20px;
                        text-decoration: none;

                        &:hover {
                            text-decoration: underline;
                        }

                        &:first-child {
                            margin-left: 0;
                        }
                    }
                }
            }
        }
    }
</style>

<script>
  export default {
    data() {
      return {
        show: true,
      };
    },
    computed: {
      footerLinks() {
        return [
          {linkTo: this.i18nLink('/imprint'), linkName: this.$tc('imprint', 2, 2)},
          {linkTo: this.i18nLink('/terms-of-use'), linkName: this.$t('terms_of_use')},
          {linkTo: this.i18nLink('/privacy-policy'), linkName: this.$t('privacy_policy')},
        ];
      },
    },
    watch: {
      '$route'(route) {
        this.show = ['cart'].indexOf(route.name) < 0;
      },
    },
    created() {
      this.show = ['cart'].indexOf(this.$router.currentRoute.name) < 0;
    },
  };
</script>